import { toastError, toastSuccess } from "helpers";
import { formatEntityName, replaceEntityName } from "helpers";
import { useTranslations } from "providers/Translations";
import { PropsWithChildren, useMemo } from "react";

import { IToastsContext, ToastsContext } from "./ToastsContext";

export const ToastsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const i18n = useTranslations();

  const value = useMemo<IToastsContext>(
    () => ({
      success: (message) => {
        return toastSuccess(message);
      },
      error: (message, err) => {
        return toastError(message, err);
      },
      addSuccess: (entity, title) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Add_Success, message);
        return toastSuccess(message);
      },
      addFailure: (entity, title, err) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Add_Failure, message);
        return toastError(message, err);
      },
      updateSuccess: (entity, title) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Update_Success, message);
        return toastSuccess(message);
      },
      updateFailure: (entity, title, err) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Update_Failure, message);
        return toastError(message, err);
      },
      deleteSuccess: (entity, title) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Delete_Success, message);
        return toastSuccess(message);
      },
      deleteFailure: (entity, title, err) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Delete_Failure, message);
        return toastError(message, err);
      },
      refreshSuccess: (entity, title) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Refresh_Success, message);
        return toastSuccess(message);
      },
      refreshFailure: (entity, title, err) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Refresh_Failure, message);
        return toastError(message, err);
      },
      saveSuccess: (entity, title) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Save_Success, message);
        return toastSuccess(message);
      },
      saveFailure: (entity, title, err) => {
        let message = formatEntityName(entity, title || i18n.EntityTitle_Unknown);
        message = replaceEntityName(i18n.Entity_Save_Failure, message);
        return toastError(message, err);
      },
    }),
    [i18n]
  );

  return <ToastsContext.Provider value={value}>{children}</ToastsContext.Provider>;
};
